import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (companyId, offerId) => {
	return fetch(
		Methods.DELETE,
		EndPoints.COMPANIES_OFFER.replace(':offerId', offerId).replace(':companyId', companyId),
		null,
		null,
		true
	);
};
